import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const AppRedirect = () => {
  const { path } = useParams<{ path: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (path) {
      let deeplink = `${process.env.REACT_APP_APP_LINK}/${path}`;

      const queryString = searchParams.toString();
      if (queryString) {
        deeplink += `?${queryString}`;
      }

      window.location.href = deeplink;
    }
  }, [path, searchParams]);

  return null;
};

export default AppRedirect;
